module.exports = __webpack_public_path__ + "static/img/db11_pc.67e4d31a.jpg";